<div
	*ngIf="!(isLoading$ | async); else loading"
	class="h-full overflow-hidden grid grid-cols-2 px-10 py-2.5 gap-x-8 gap-y-3 grid-rows-[min-content_40px_1fr]"
>
	<div class="col-span-2 mb-2">
		<div>
			<app-breadcrumb [items]="breadcrumbItems$ | async"></app-breadcrumb>
		</div>
		<div
			class="flex justify-start mt-2"
			*ngIf="(showTagsConvertedWarning$ | async) && (canResetDocument$ | async)"
		>
			<atomic-message-bar type="warn" [shadow]="false"
				>Tags have been converted. This document is no longer synced with file
				selections.<button
					(click)="resetDocument()"
					[disabled]="(documentBusy$ | async) || (documentUpdating$ | async)"
					class="ml-4 font-semibold"
				>
					Reset document
				</button></atomic-message-bar
			>
		</div>
	</div>

	<div class="flex items-center text-[22px] font-bold text-grey-darker">
		<span
			class="overflow-hidden text-ellipsis whitespace-nowrap flex-auto"
			[matTooltip]="viewingDocumentTitle"
			>{{ viewingDocumentTitle }}</span
		>
		<atomic-kebab-options
			[itemGroups]="documentActions$ | async"
			(onSelect)="onActionSelect($event)"
			[disabled]="(documentBusy$ | async) || (documentUpdating$ | async)"
		></atomic-kebab-options>
	</div>

	<app-documents-matter-viewer
		class="row-span-2 border-b border-b-grey-light"
		[fileName]="viewingDocumentTitle"
	></app-documents-matter-viewer>

	<app-documents-matter-editor></app-documents-matter-editor>
</div>

<ng-template #loading>
	<div class="flex w-full h-full items-center justify-center text-grey-light">
		<div class="flex flex-col items-center">
			<app-icon class="text-5xl" [icon]="ICON.LOADING" [spin]="true"></app-icon>
			<span class="mt-5 font-bold text-lg"
				>PREPARING YOUR
				<span class="text-green text-4xl mx-3">CLOSER</span> DOCUMENT</span
			>
		</div>
	</div>
</ng-template>
